import axios from "axios";
import { APIURL } from "../config";
import useAuth from "../utils/useAuth";


const CreateRoleAPI = async (data) => {
    const user = useAuth()
    const url = APIURL + "/admin/addrole"
    return await axios.post(url, { access_token: user.token, ...data })
}

export default CreateRoleAPI